import * as React from "react";
import styled from "styled-components";
import InputForm from "./InputForm";

const NameFormContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

interface props {
  onChange?: ((firstName: string, lastName: string) => void);
}

interface state {
  firstName: string;
  lastName: string;
}

class SingleNameForm extends React.Component<props, state> {
  state = {
    firstName: "",
    lastName: ""
  };

  render() {
    return (
      <NameFormContainer>
        <InputForm
          InputTitleText="First Name"
          InputPlaceholderText="Amy"
          rightBorder={true}
          onChange={firstName =>
            this.setState({ firstName }, () => {
              this.props.onChange &&
                this.props.onChange(this.state.firstName, this.state.lastName);
            })
          }
        />
        <InputForm
          InputTitleText="Last Name"
          InputPlaceholderText="Gutmann"
          onChange={lastName =>
            this.setState({ lastName }, () => {
              this.props.onChange &&
                this.props.onChange(this.state.firstName, this.state.lastName);
            })
          }
        />
      </NameFormContainer>
    );
  }
}

export default SingleNameForm;



// WEBPACK FOOTER //
// ./src/components/FormComponents/SingleNameForm.tsx